/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import ErrorModule from 'app/mixins/ErrorModule.jsx';
import FieldError from 'app/components/common/FieldError.jsx';
import ToggleControl from 'app/components/common/ToggleControl.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class RouteTrackingPanel extends React.Component {
    constructor(props) {
        super(props);

        this.setGoogleTemplate = this.setGoogleTemplate.bind(this);
        this.defaultToggle = this.defaultToggle.bind(this);

    }

    setGoogleTemplate(e) {
        let faker = {
            currentTarget: {
                dataset: {
                    field: 'route.urlAppend'
                }
            },
            target: {
                value: 'utm_source=dlvr.it&utm_medium=[desttype]&utm_campaign=[destname]'
            }
        };
        e.preventDefault();

        this.props.changeHandler.apply(this, [faker]);
    }

    defaultToggle(e) {

        let value = (e.currentTarget.dataset.togglestate === 'true') ? 0 : 1,
            faker = {
                currentTarget: {
                    dataset: {
                        field: 'route.urlAppend'
                    }
                },
                target: {
                    value: null
                }
            };

        e.preventDefault();

        if (!value) {
            faker.target.value = '';
        }

        this.props.changeHandler.apply(this, [faker]);

    }

    render() {
        let urlAppend = '',
            toggleActive = false,
            textareaDisabled = '',
            textareaClass = '';

        if (this.props.route.urlAppend === null) {
            toggleActive = true;
            textareaDisabled = 'disabled';
            textareaClass = 'inactive';
        } else {
            urlAppend = this.props.route.urlAppend;
        }

        return (
            <div className="editor-panel">
                <form>
                    <fieldset>
                        <legend>
                            Analytics<HelpButton which="urlAppend"/>
                            <div className="toggle-float-right">
                                <ToggleControl
                                    active={toggleActive}
                                    activeLabel="Use Default Tracking"
                                    inactiveLabel="Use Tracking Below"
                                    callback={this.defaultToggle}/>
                            </div>
                        </legend>
                        <p className="editor-copy">Add analytics to your links for enhanced reporting from your site analytics service.</p>
                        <ErrorModule
                            app={this.props.app}
                            keys={['ROUTE_CREATE', 'ROUTE_UPDATE']}
                            render={(state) => {
                                return (
                                    <FieldError field="urlAppend" errors={state.errors}/>
                                );
                            }}/>
                        <textarea value={urlAppend} disabled={textareaDisabled} className={"text-area " + textareaClass} onChange={this.props.changeHandler} data-field="route.urlAppend"></textarea>

                        <a href="#" className="google-template" onClick={this.setGoogleTemplate}>Generate a link for Google Analytics</a>

                        <div className="analytics-variables">
                            <div className="editor-copy">Variables available for use in your links<HelpButton which="trackingVariables"/></div>
                            <ul className="analytics-variable-list">
                                <li className="analytics-variable">
                                    <div className="variable-name">
                                        [feedurl]
                                    </div>
                                    <div className="variable-desc">
                                        If your source is a feed, the source url of that feed
                                    </div>
                                </li>
                                <li className="analytics-variable">
                                    <div className="variable-name">
                                        [sourcename]
                                    </div>
                                    <div className="variable-desc">
                                        The name of your feed (urlencoded).
                                    </div>
                                </li>
                                <li className="analytics-variable">
                                    <div className="variable-name">
                                        [desttype]
                                    </div>
                                    <div className="variable-desc">
                                        Where the item was posted, facebook or twitter, as examples.
                                    </div>
                                </li>
                                <li className="analytics-variable">
                                    <div className="variable-name">
                                        [destname]
                                    </div>
                                    <div className="variable-desc">
                                        The account name tied to your destination (urlencoded).
                                    </div>
                                </li>
                                <li className="analytics-variable">
                                    <div className="variable-name">
                                        [routename]
                                    </div>
                                    <div className="variable-desc">
                                        The name of your route (urlencoded).
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </fieldset>
                </form>
            </div>
        );
    }

};

RouteTrackingPanel.displayName = "RouteTrackingPanel";

RouteTrackingPanel.propTypes = {
    route: PropTypes.object,
    routeViewType: PropTypes.number,
    userPerms: PropTypes.object,
    changeHandler: PropTypes.func,
    errors: PropTypes.object
};

RouteTrackingPanel.defaultProps = {
    route: {},
    routeViewType: 0,
    userPerms: {},
    changeHandler: null,
    errors: null
};

export default ComponentWithContext(RouteTrackingPanel);
